import { CalendarApp, createViewWeek } from '@schedule-x/calendar'
import { createEventModalPlugin } from '@schedule-x/event-modal'
import { createEventsServicePlugin } from '@schedule-x/events-service'
import { useCalendarApp } from '@schedule-x/react'
import { addDays } from 'date-fns'
import { useEffect, useState } from 'react'
import { useRemoteClientPost } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { parseSession } from './parse-session'

export const LoadSessionsDate = () => {
  const [loading, setLoading] = useState(false)
  const { httpClientPost } = useRemoteClientPost()
  const { getUnitId } = useLocalStorage()
  const eventsService = useState(() => createEventsServicePlugin())[0]
  const eventModal = createEventModalPlugin()

  const [calendarItems, setCalendarItems] = useState<any[]>([])
  const calendarSessions: CalendarApp | null = useCalendarApp({
    isDark: false,
    locale: 'pt-BR',
    isResponsive: true,
    views: [createViewWeek()],
    theme: 'shadcn',
    callbacks: {
      onRangeUpdate: (data) => {
        const { start, end } = data

        if (!loading) {
          setLoading(true)
          httpClientPost('/aulas/filtro?page=0&size=1000', {
            inicioAula: new Date(new Date(start).setUTCHours(0, 0, 0, 0)).toISOString(),
            fimAula: new Date(new Date(end).setUTCHours(23, 59, 59, 999)).toISOString(),
            status: 1,
            unidade: {
              id: getUnitId()
            }
          })
            .then((response) => {
              try {
                const data = response.data.data.content.map((session: any) => parseSession({ ...session, reloadSession: reloadSessions }))
                setCalendarItems(data)
              } catch (error) {
                console.error('Error parsing sessions:', error)
              }
            })
            .catch((e) => {
              console.error(e)
              return CatchMessageError(e)
            })
            .finally(() => setLoading(false))
        }
      }
    },
    events: [],
    plugins: [eventsService, eventModal]
  })
  const setCalendarSessions = (data: any) => {
    console.debug('calendario-dbg', { calendarSessions, data })
    calendarSessions?.events.set(data)
  }

  const reloadSessions = () => {
    const start = new Date()
    start.setUTCHours(0, 0, 0, 0)

    const end = addDays(new Date(), 6)
    end.setUTCHours(23, 59, 59, 999)

    loadSessions({
      start: start.toISOString(),
      end: end.toISOString()
    })
  }

  const loadSessions = (data: any) => {
    const { start, end } = data
    if (!loading) {
      setLoading(true)
      httpClientPost('/aulas/filtro?page=0&size=1000', {
        inicioAula: new Date(new Date(start).setUTCHours(0, 0, 0, 0)).toISOString(),
        fimAula: new Date(new Date(end).setUTCHours(23, 59, 59, 999)).toISOString(),
        status: 1,
        unidade: {
          id: getUnitId()
        }
      })
        .then((response) => {
          try {
            const data = response.data.data.content.map((session: any) => parseSession({ ...session, reloadSession: reloadSessions }))
            setCalendarItems(data)
          } catch (error) {
            console.error('Error parsing sessions:', error)
          }
        })
        .catch((e) => {
          console.error(e)
          return CatchMessageError(e)
        })
        .finally(() => setLoading(false))
    }
  }

  useEffect(() => {
    const start = new Date()
    start.setHours(0, 0, 0, 0) // 00:00:00.000

    const end = addDays(new Date(), 6)
    end.setHours(23, 59, 59, 999) // 23:59:59.999

    loadSessions({ start, end })
  }, [])

  useEffect(() => {
    if (calendarSessions && calendarItems.length > 0) {
      setCalendarSessions(calendarItems)
    }
  }, [calendarSessions, calendarItems])

  return {
    reloadSessions,
    calendarSessions
  }
}
